module.exports = __webpack_public_path__ + "img/logo.03499e39.png";